import { formatSecToHourString } from 'helpers/conversions';
import { TimeFrame } from 'models/ReportData';
import React from 'react';
import { Box } from '@mui/material';
import DesktopAverageProductionRateCardDtf from './DesktopAverageProductionRateCardDtf';
import { desktopDtgApolloTopCardsStyles } from './DesktopDtgApolloTopCards.styles';
import DesktopTotalImpressionCardDtf from './DesktopTotalImpressionCard';
import { ITopCardsProps } from './TopCardsContainer';
import DesktopAverageAvailabilityCardDtf from './DesktopAverageAvailabilityCardDtf';

const DesktopDtfTopCards = (props: ITopCardsProps) => {
  const {
    totalProduction,
    units,
    productionTrend,
    selectedSystemGroup,
    selectedSystemGroupText,
    timeframe,
    productionRateTrend,
    productionRate,
    utilization,
    trendUtilization,
    preparation,
    trendPreparation,
    errorDuration,
    availabilityTrend,
    availability,
    maintenanceDurationTrend,
    maintenanceDuration,
    errorDurationTrend,
    customTimeframeProperties,
  } = props;
  const getTimeframeTextKey = () => {
    return timeframe && timeframe.includes('lastUpdate') ? 'last' : 'weekDay';
  };
  const changeTextPerPage = (timeframe: TimeFrame | '', text: string) => {
    if (timeframe && timeframe.includes('lastUpdate')) return text.replace('Average', 'Current');
    return text;
  };
  return (
    <Box display="flex" gap="16px" sx={desktopDtgApolloTopCardsStyles.topCardsDesktopWrapper}>
      <Box
        display="flex"
        boxSizing="border-box"
        height="144px"
        sx={{ ...desktopDtgApolloTopCardsStyles.totalImpressionCardWrapper, width: '33%' }}>
        <DesktopTotalImpressionCardDtf
          customTimeframeProperties={customTimeframeProperties}
          value={totalProduction}
          units={units}
          stats={productionTrend}
          selectedSystemGroup={selectedSystemGroup}
          selectedSystemGroupText={selectedSystemGroupText}
          description={selectedSystemGroupText.impression.description[getTimeframeTextKey()]}
          timeframe={timeframe}
        />
      </Box>

      <Box
        display="flex"
        boxSizing="border-box"
        height="144px"
        sx={{ ...desktopDtgApolloTopCardsStyles.averageProductionRateCardWrapper, width: '33%' }}>
        <DesktopAverageProductionRateCardDtf
          selectedSystemGroup={selectedSystemGroup}
          customTimeframeProperties={customTimeframeProperties}
          value={productionRate}
          units={units + '/h'}
          description={selectedSystemGroupText.productionRate.description[getTimeframeTextKey()]}
          stats={productionRateTrend}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '%',
              value: utilization,
              description: changeTextPerPage(
                timeframe,
                selectedSystemGroupText.productionRate.upper
              ),
              trend: trendUtilization,
            },
            lower: {
              value: preparation,
              description: selectedSystemGroupText.productionRate.lower,
              unit: '%',
              trend: trendPreparation,
            },
          }}
        />
      </Box>
      <Box
        display="flex"
        boxSizing="border-box"
        height="144px"
        sx={{ ...desktopDtgApolloTopCardsStyles.averageAvailabilityCardWrapper, width: '33%' }}>
        <DesktopAverageAvailabilityCardDtf
          customTimeframeProperties={customTimeframeProperties}
          cardName="availability"
          value={availability}
          units={'%'}
          isPercentage={true}
          description={selectedSystemGroupText.availability.description[getTimeframeTextKey()]}
          stats={availabilityTrend}
          statsDescription={
            selectedSystemGroupText.availability.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '',
              value: errorDuration,
              description: selectedSystemGroupText.availability.upper,
              trend: errorDurationTrend,
              formatter: formatSecToHourString,
            },
            lower: {
              value: maintenanceDuration,
              unit: '',
              description: selectedSystemGroupText.availability.lower,
              trend: maintenanceDurationTrend,
              formatter: formatSecToHourString,
            },
          }}
        />
      </Box>
    </Box>
  );
};
export default DesktopDtfTopCards;
